import { BasicEvent } from "~app/features/planera/events/BasicEvent";

export class ArbetsorderViol3SynchronizationData extends BasicEvent {
    arbetsorderId: number;
    messageType: string;
    dirtyProduktion: boolean;
    dirtyTransport: boolean;
    hasTransmissionErrorProduktion: boolean;
    hasTransmissionErrorTransport: boolean;
    documentNumber: string;
    deliverySourceNumber: string;
    skickadTillViol3: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ArbetsorderViol3SynchronizationData";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static messageType = "Arbetsorder";
}
